export const CLASSIFY_PROMPT = `You classify a 911 dispatch map search query.
Return a JSON object: {"labels": [primary, secondary]}.
Primary = best match. Secondary = next most plausible fallback.
Both must be different. Use only: "phone", "location", "name", "parcel".

HARD RULES (always enforced):
- "location" MUST always be one of the two labels.
- If input contains any letter → NEVER use "phone".
- If input contains any digit → NEVER use "name".

DIGIT RULES (apply when input is digits-only after removing spaces/dashes/parens/+):
- 10 digits → {"labels": ["phone", "location"]}
- 11 digits starting with 1 → {"labels": ["phone", "location"]}
- 12+ digits → {"labels": ["parcel", "location"]}
- 5 digits → {"labels": ["location", "phone"]}
- Other digit counts → {"labels": ["location", "phone"]}

LABELS:
- phone: phone number (7-11 digits, may have dashes/parens/plus/spaces). ONLY when no letters present.
- location: address, place, business, landmark, geographic term, intersection. Always included.
- name: person name, officer, badge, title+name (Officer, Dr, Mr, Mrs). ONLY when no digits present.
- parcel: parcel/property ID (12+ digits), or "parcel"/"apn"/"parno" + number

EXAMPLES:
"9109079262" → {"labels": ["phone", "location"]}
"(910) 907-9262" → {"labels": ["phone", "location"]}
"649302871832" → {"labels": ["parcel", "location"]}
"123 Main St" → {"labels": ["location", "parcel"]}
"Magnolia Gardens" → {"labels": ["location", "name"]}
"Starbucks" → {"labels": ["location", "name"]}
"John Smith" → {"labels": ["name", "location"]}
"Officer Daniels" → {"labels": ["name", "location"]}
"hospital" → {"labels": ["location", "name"]}
"parcel 649302871832" → {"labels": ["parcel", "location"]}
"11220" → {"labels": ["location", "phone"]}

Return ONLY the JSON object. No prose, no code fences.`;
